import ButtonT from '@components/tailwind-components/Button/ButtonT';
import SelectInputWithLabelT from '@components/tailwind-components/Input/SelectInputWithLabelT';
import type {
  Handover,
  THandoverInitForm,
} from '@conversed/shared/src/central/types/blocks/Handover';
import { useBlocksUpdates } from '@hooks/flow/block/useBlocksUpdates';
import { useInboxes } from '@hooks/settings/inboxes/useInboxes';
import { t } from 'i18next';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { useModal } from '../../../hooks/modal/useModal';
import { useMainSelector } from '../../../hooks/useMainSelector';

export const HandoverSelectInboxModal: React.FC<{ block: Handover }> = ({
  block,
}) => {
  const { hideModal } = useModal();
  const { updateBlocks } = useBlocksUpdates();
  const { inboxes } = useInboxes();

  const {
    ui: { activeModal },
  } = useMainSelector();

  const onSubmitHandoverBlock = useCallback(
    (handover: THandoverInitForm) => {
      if (handover?.params?.inbox) {
        updateBlocks([{ ...block, ...handover }]);
        hideModal();
      }
    },
    [updateBlocks, hideModal, block],
  );

  const { handleSubmit, control } = useForm({
    defaultValues: {
      params: {
        inbox: '',
      },
    },
    shouldUseNativeValidation: true,
  });

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(onSubmitHandoverBlock)}
      id={activeModal?.title}>
      <div className='tailwind-modal-body'>
        <SelectInputWithLabelT
          field='params.inbox'
          label={t('flow.form.description.handover-inbox')}
          control={control}
          values={inboxes?.map((inbox) => ({
            value: inbox.identifier,
            description: inbox.name,
          }))}
        />
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={() => {
            hideModal();
          }}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT
          type='submit'
          styling='primary'
          size='xs'
          rounding='md'
          disabled={!inboxes?.length}>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};
